import React from 'react';
import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { getAllRoles } from '../../../../Services/roleService';
import { loadFor } from '../../../../Services/checklistService';
import { findSaved, saveBidteam } from '../../../../Services/bidteamService';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { Tooltip } from 'primereact/tooltip';
import { RadioButton } from 'primereact/radiobutton';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import moment from "moment";
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import { useNavigate } from 'react-router-dom';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { Dialog } from 'primereact/dialog';

const Milestones = (props) => {
	const [loading, setLoading] = useState(false);
	const [newModule, setNewModule] = useState({});
	const [gatewayPermissions, setGatewayPermissions] = useState([]);
	const [gateChecklist, setGateChecklist] = useState([]);
	const [opportunityData, setOpportunityData] = useState({});
	const [approveGateWay, setApproveGateWay] = useState(false);
	const [individualScore, setIndividualScore] = useState([]);
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const navigate = useNavigate()
	const [showVideo, setShowVideo] = useState(false);
	const toastRef = useRef();

	const enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}

	const userId = tmpData.userid;
	const curCustomer = tmpData.customer;
	const role = tmpData.role;

	const userprivileges = localStorage.getItem("user_privileges");
	if (userprivileges) {
		var user_privileges = JSON.parse(userprivileges);
		if (user_privileges !== undefined && user_privileges !== null) {
			var gateClosePrivilege = user_privileges[0].gate_closer;
		}
	}

	useEffect(() => {
		if (props.customerId) {
			allRoles()
		}
	}, [props.customerId])

	useEffect(() => {
		if (props.individualScore.length > 0) {
			setIndividualScore(props.individualScore)
		}
	}, [props.individualScore])

	useEffect(() => {
		if (props.fieldData.pipelineGatewaysSections) {
			let obj1 = _.find(props?.fieldData?.pipelineGatewaysSections, { section_name: "Gateway Approval Dates" })?.display_name;
			let obj2 = _.find(props?.fieldData?.pipelineGatewaysSections, { section_name: "Gateway Status" })?.display_name;
			let obj3 = _.find(props?.fieldData?.pipelineGatewaysSections, { section_name: "Checklist" })?.display_name;
			let combined = { obj1, obj2, obj3 };
			setNewModule(combined)
		}
	}, [props.fieldData.pipelineGatewaysSections])

	useEffect(() => {
		if (props.opportunityData && gatewayPermissions) {
			setOpportunityData(props.opportunityData)
			gatewayLoad(props.opportunityData)
		}
	}, [props.opportunityData, gatewayPermissions])

	useEffect(() => {
		setGlobalOpportunityData(opportunityData);
	}, [opportunityData]);

	// useEffect(() => {
	// 	setGlobalOpportunityData((prevData) => ({
	// 		...prevData,
	// 		gateways: opportunityData.gateways
	// 	}));
	// }, [opportunityData.gateways]);

	// useEffect(() => {
	// 	setGlobalOpportunityData((prevData) => ({
	// 		...prevData,
	// 		approvals: opportunityData.approvals
	// 	}));
	// }, [opportunityData.approvals]);

	// const allRoles = async () => {
	// 	var data = await getAllRoles(props.customerId, true)

	// 	if (data) {
	// 		var roles = data.data.roles;

	// 		var gatewayPermissions = roles.find(role => role.role_name === tmpData.role)?.gateway_permissions;
	// 		setGatewayPermissions(gatewayPermissions)
	// 	}
	// }
	const allRoles = async () => {
		try {
			setLoading(true);

			const data = await getAllRoles(props.customerId, true);

			if (data && data.data) {
				const roles = data.data.roles;

				// Find gateway permissions for the specified role
				const gatewayPermissions = roles.find(role => role.role_name === tmpData.role)?.gateway_permissions;
				setGatewayPermissions(gatewayPermissions);
			} else {
				// Handle the case where data is not structured as expected
				toastRef.current.showToast({
					type: "error",
					message: "No roles found or data is not available."
				});
			}
		} catch (error) {
			// Handle any errors during the API request
			toastRef.current.showToast({
				type: "error",
				message: "Failed to fetch roles. Please try again or contact Admin."
			});
		} finally {
			setLoading(false);
		}
	};


	const gatewayLoad = async (opportunityDetails) => {
		try {
			var approveGW = false;
			var bidTeam = opportunityDetails.ie_bid_team?.internal_bid_team;

			if (gatewayPermissions && gatewayPermissions[opportunityDetails.winwork_stage] == true) {
				approveGW = true;
			}
			setApproveGateWay(approveGW)

			//checklist approvals
			var checkdata = await loadFor(curCustomer, opportunityDetails.winwork_stage, "Gateway", opportunityDetails.sector)

			if (checkdata.data.length > 0) {
				var findUserBidRole = _.find(bidTeam, { user_id: userId });
				var bidTeamRole = findUserBidRole?.bid_team_role;

				var result = await findSaved(curCustomer, bidTeamRole, opportunityDetails._id, opportunityDetails.winwork_stage)
				var data = result.data.data;
				var access = false;

				const userprivileges = localStorage.getItem("user_privileges");
				if (userprivileges) {
					var user_privileges = JSON.parse(userprivileges);
					if (user_privileges !== undefined && user_privileges !== null) {
						var checklist_prompts_access = user_privileges[0].checklist_prompts_access;
					}

					if (checklist_prompts_access) {
						access = true;
					} else {
						for (var x = 0; x < bidTeam.length; x++) {
							if (bidTeam[x].user_id == userId) {
								access = true;
							}
						}
					}
				}

				var gateChecklist = [];

				if (access == true) {
					if (data) {
						if (data.gateway.checklist.length > 0) {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < checkdata.data.length; i++) {
									var informed_users = checkdata.data[i].informed_users;
									var contributing_users = checkdata.data[i].contributing_users;
									var accountable_users = checkdata.data[i].accountable_users;
									var responsible_users = checkdata.data[i].responsible_users;
									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											var status = false;
											for (var y = 0; y < data.gateway.checklist.length; y++) {
												if (data.gateway.checklist[y].check == checkdata.data[i].checklist_item + " (I)" && data.gateway.checklist[y].status) {
													status = true;
													break;
												}
											}
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (I)",
												status: status,
											});
										}
									}
									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											var status = false;
											for (var y = 0; y < data.gateway.checklist.length; y++) {
												if (data.gateway.checklist[y].check == checkdata.data[i].checklist_item + " (C)" && data.gateway.checklist[y].status) {
													status = true;
													break;
												}
											}
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (C)",
												status: status,
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											var status = false;
											for (var y = 0; y < data.gateway.checklist.length; y++) {
												if (data.gateway.checklist[y].check == checkdata.data[i].checklist_item + " (A)" && data.gateway.checklist[y].status) {
													status = true;
													break;
												}
											}
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (A)",
												status: status,
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											var status = false;
											for (var y = 0; y < data.gateway.checklist.length; y++) {
												if (data.gateway.checklist[y].check == checkdata.data[i].checklist_item + " (R)" && data.gateway.checklist[y].status) {
													status = true;
													break;
												}
											}
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (R)",
												status: status,
											});
										}
									}
								}
							}
						} else {
							if (result?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < checkdata.data.length; i++) {
									var informed_users = checkdata.data[i].informed_users;
									var contributing_users = checkdata.data[i].contributing_users;
									var accountable_users = checkdata.data[i].accountable_users;
									var responsible_users = checkdata.data[i].responsible_users;

									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (I)",
												status: false,
											});
										}
									}

									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (C)",
												status: false,
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (A)",
												status: false,
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											gateChecklist.push({
												check: checkdata.data[i].checklist_item + " (R)",
												status: false,
											});
										}
									}
								}
							}
						}
					} else {
						for (var i = 0; i < checkdata.data.length; i++) {
							var informed_users = checkdata.data[i].informed_users;
							var contributing_users = checkdata.data[i].contributing_users;
							var accountable_users = checkdata.data[i].accountable_users;
							var responsible_users = checkdata.data[i].responsible_users;

							for (var j = 0; j < informed_users.length; j++) {
								if (bidTeamRole == informed_users[j].role) {
									gateChecklist.push({
										check: checkdata.data[i].checklist_item + " (I)",
										status: false,
									});
								}
							}

							for (var j = 0; j < contributing_users.length; j++) {
								if (bidTeamRole == contributing_users[j].role) {
									gateChecklist.push({
										check: checkdata.data[i].checklist_item + " (C)",
										status: false,
									});
								}
							}
							if (accountable_users != null) {
								if (bidTeamRole == accountable_users.role) {
									gateChecklist.push({
										check: checkdata.data[i].checklist_item + " (A)",
										status: false,
									});
								}
							}

							for (var j = 0; j < responsible_users.length; j++) {
								if (bidTeamRole == responsible_users[j].role) {
									gateChecklist.push({
										check: checkdata.data[i].checklist_item + " (R)",
										status: false,
									});
								}
							}
						}
					}
				}
				setGateChecklist(gateChecklist)
			}
		} catch (error) {
			// Handle any errors that occurred during the API calls
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or contact Admin.'
			});
		}
	}

	// const gate_check_change = async (e, index, field) => {
	// 	var findUserBidRole = _.find(opportunityData.ie_bid_team.internal_bid_team, { user_id: userId });

	// 	if (findUserBidRole != undefined || findUserBidRole != null) {
	// 		var gateChanges = {};
	// 		gateChanges.opportunity_id = opportunityData._id;
	// 		gateChanges.customer_id = curCustomer;
	// 		gateChanges.winstage = opportunityData.winwork_stage;
	// 		gateChanges.gateway = {};

	// 		//checklist
	// 		var checklist = [];
	// 		for (var i = 0; i < gateChecklist.length; i++) {
	// 			if (index == i) {
	// 				gateChecklist[index].status = (field == 'checklist') ? e.checked : gateChecklist[index].status
	// 			}
	// 			checklist.push(gateChecklist[i]);
	// 		}
	// 		gateChanges.gateway.checklist = checklist;
	// 		gateChanges.bid_team_role = findUserBidRole?.bid_team_role;

	// 		var res = await saveBidteam(tmpData.role, gateChanges)
	// 		gatewayLoad(opportunityData)
	// 	}
	// }
	const gate_check_change = async (e, index, field) => {
		try {
			setLoading(true);

			// Find the user's bid role in the internal bid team
			var findUserBidRole = _.find(opportunityData.ie_bid_team.internal_bid_team, { user_id: userId });

			// Check if the user bid role exists
			if (findUserBidRole != undefined || findUserBidRole != null) {
				var gateChanges = {
					opportunity_id: opportunityData._id,
					customer_id: curCustomer,
					winstage: opportunityData.winwork_stage,
					gateway: {}
				};

				// Create the updated checklist
				var checklist = gateChecklist.map((item, i) => {
					if (index === i) {
						// Update the status if the index matches and the field is 'checklist'
						return {
							...item,
							status: field === 'checklist' ? e.checked : item.status
						};
					}
					return item; // Return the unchanged item
				});

				// Assign the updated checklist to gateChanges
				gateChanges.gateway.checklist = checklist;
				gateChanges.bid_team_role = findUserBidRole.bid_team_role;

				// Save the bid team changes
				const res = await saveBidteam(tmpData.role, gateChanges);
				if (res && res.data && res.data.success) {
					// Optionally handle successful response
					toastRef.current.showToast({
						type: 'success',
						message: 'Bid team changes saved successfully.',
					});
				} else {
					// Handle unsuccessful response
					toastRef.current.showToast({
						type: 'error',
						message: res?.data?.message || 'Failed to save bid team changes.',
					});
				}

				gatewayLoad(opportunityData);
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: 'User bid role not found. Please check your permissions.',
				});
			}
		} catch (error) {
			// Handle any unexpected errors
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred while processing your request. Please try again or contact Admin.',
			});
		} finally {
			setLoading(false);
		}
	};


	const statusTemplate = (rowData, ind) => {
		return (
			<CheckboxElement
				id={`check-${ind.rowIndex}`}
				name={`check-${ind.rowIndex}`}
				value={rowData.status}
				checked={rowData.status}
				onChangeCheck={(e) => gate_check_change(e, ind.rowIndex, 'checklist')}
				className="mr-2"
			/>
		)
	}

	const columns = [
		{ field: "check", header: _.find(props.fieldData.oppGatewaysTable, { table_name: "Gateway checklist for winWork Stage" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
		{ field: "status", header: "", body: statusTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
	]

	const stageTemplate = (rowData) => {
		const filteredStages = props.winWorkStage.length > 0 && props.winWorkStage.filter(stage => stage.label === rowData.gate);

		if (filteredStages.length > 0) {
			return (
				<>
					{filteredStages.map((stage, index) => (
						<span key={index}>{stage.text}</span>
					))}
				</>
			);
		}
	};

	const findWithAttr = (attr, value) => {
		for (var i = 0; i < props.winstages.length; i += 1) {
			if (props.winstages[i][attr] === value) {
				return i;
			}
		}
	};

	const closeGate = (by) => {
		setLoading(true)
		var opportunityDataCopy = opportunityData
		if ((by == "user" && gateClosePrivilege) || by == "auto") {
			//updating last obj
			var lastObj = opportunityDataCopy.gateways.gateway_status.pop();
			if (by == "user") {
				var closed_opportunity = {};
				for (var i = 0; i < individualScore.length; i++) {
					if (individualScore[i] != undefined) {
						if (opportunityData.opportunity_type == individualScore[i].text) {
							closed_opportunity["purpose_connectivity"] = individualScore[i];
						}
						if (opportunityData.project_margin == individualScore[i].text) {
							closed_opportunity["value_creation"] = individualScore[i];
						}
						if (opportunityData.additional.resourcing_bid == individualScore[i].text) {
							closed_opportunity["risk"] = individualScore[i];
						}
						if (opportunityData.additional.resourcing_project == individualScore[i].text) {
							closed_opportunity["geographic_impact"] = individualScore[i];
						}
						if (opportunityData.additional.no_of_competitors == individualScore[i].text) {
							closed_opportunity["value_chain_partners"] = individualScore[i];
						}
						if (opportunityData.additional.bond_requirement == individualScore[i].text) {
							closed_opportunity["investor_shareholder_value"] = individualScore[i];
						}
						if (opportunityData.opportunity.client_meetings == individualScore[i].text) {
							closed_opportunity["depth_of_stakeholder_engagement"] = individualScore[i];
						}
					}
				}
				var newObj = {
					gate: lastObj.gate,
					role: role,
					closed_by: tmpData.username,
					status: "closed",
					closed_date: moment().format('DD-MM-YYYY'),
					closed_time: moment().format('HH:mm'),
					win_score: opportunityData.win_score,
					closed_opportunities: closed_opportunity,
				};
				opportunityDataCopy.gateways.gateway_status.push(newObj);
			} else {
				var newObj = {
					gate: lastObj.gate,
					role: "Auto",
					closed_by: "Auto",
					status: "closed",
					closed_date: moment().format('DD-MM-YYYY'),
					closed_time: moment().format('HH:mm'),
					win_score: opportunityData.win_score,
				};
				opportunityDataCopy.gateways.gateway_status.push(newObj);
			}

			var tmpStage = ''
			var nextIndex = findWithAttr("stage", lastObj.gate);
			if (lastObj.gate != "Feedback") {
				opportunityDataCopy.gateways.gateway_status.push({
					gate: props.winstages[nextIndex + 1].stage,
					status: "open",
				});
				tmpStage = opportunityDataCopy.winwork_stage;
				opportunityDataCopy.winwork_stage = props.winstages[nextIndex + 1].stage;
			} else {
				tmpStage = opportunityDataCopy.winwork_stage;
			}

			if (lastObj.gate.toLowerCase() === "submission") {
				var midGateActDate = "act_" + lastObj.gate.toLowerCase() + "_mid_phase_gateway_approval";
				var midGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_mid_phase_gateway_approval";
				opportunityDataCopy.gateways[midGateActDate].checked = true;
				opportunityDataCopy.gateways[midGateActDate].value = "Act";
				opportunityDataCopy.gateways[midGateActDate].text = moment().format("DD-MM-YYYY");
				opportunityDataCopy.gateways[midGateEstDate].checked = false;
			} else if (lastObj.gate.toLowerCase() === "deliver") {
				var midGateActDate = "act_" + lastObj.gate.toLowerCase() + "_mid_phase_approval";
				var midGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_mid_phase_approval";
				opportunityDataCopy.gateways[midGateActDate].checked = true;
				opportunityDataCopy.gateways[midGateActDate].value = "Act";
				opportunityDataCopy.gateways[midGateActDate].text = moment().format("DD-MM-YYYY");
				opportunityDataCopy.gateways[midGateEstDate].checked = false;
			} else if (lastObj.gate.toLowerCase() === "pre-qualify") {
				var midGateActDate = "act_pre_qualify_gateway_approval";
				var midGateEstDate = "est_pre_qualify_gateway_approval";
				opportunityDataCopy.gateways[midGateActDate].checked = true;
				opportunityDataCopy.gateways[midGateActDate].value = "Act";
				opportunityDataCopy.gateways[midGateActDate].text = moment().format("DD-MM-YYYY");
				opportunityDataCopy.gateways[midGateEstDate].checked = false;
			}

			var currentGateActDate = "act_" + lastObj.gate.toLowerCase() + "_gateway_approval";
			var currentGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_gateway_approval";
			if (opportunityDataCopy.gateways[currentGateActDate]) {
				opportunityDataCopy.gateways[currentGateActDate].checked = true;
				opportunityDataCopy.gateways[currentGateActDate].value = "Act";
				opportunityDataCopy.gateways[currentGateActDate].text = moment().format("DD-MM-YYYY");
			}

			if (opportunityDataCopy.gateways[currentGateEstDate]) {
				opportunityDataCopy.gateways[currentGateEstDate].checked = false;
			}

			//updating opp
			var currStage = opportunityDataCopy.winwork_stage;
			//Auto approval of Action items
			for (var i = 0; i < opportunityDataCopy.approvals.length; i++) {
				if (opportunityDataCopy.approvals[i].approved != true) {
					opportunityDataCopy.approvals[i].approved = true;
					opportunityDataCopy.approvals[i].approved_date = moment().format('DD-MM-YYYY');
					opportunityDataCopy.approvals[i].approved_time = moment().format('HH:mm');
					opportunityDataCopy.approvals[i].approved_by = "Auto";
					opportunityDataCopy.approvals[i].due_date = opportunityData.due_date;
				}
			}
			setGlobalOpportunityData((prevState) => ({
				...prevState,
				approvals: opportunityDataCopy.approvals,
				winwork_stage: opportunityDataCopy.winwork_stage,
				gateways: opportunityDataCopy.gateways,
			}))
			// setOpportunityData(opportunityDataCopy)
			// props.saveOpp()
			toastRef.current.showToast({
				type: 'success',
				message: "Gateway Closed"
			});
			setLoading(false)
		} else {
			toastRef.current.showToast({
				type: 'error',
				message: "Permission Denied"
			});
			setLoading(false)
		}
		gatewayLoad(opportunityData)
	};

	const closeTemplate = (rowData) => {
		if (rowData.status == 'open' && approveGateWay) {
			return <ButtonElement type='button' label="Close Gate" className="approve-button" onClick={() => closeGate('user')} />
		} else if (rowData.status == 'closed') {
			return <span>Closed</span>
		}
	}

	const columns1 = [
		{ field: "text", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Gate" })?.display_name, body: stageTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '18%' } },
		{ field: "role", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Role" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '13%' } },
		{ field: "closed_date", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Closed Date" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '10%' } },
		{ field: "closed_time", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Closed Time" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '10%' } },
		{ field: "win_score", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "winScore at Gateway Close" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
		{ field: "closed_by", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Closed By" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '10%' } },
		{ field: "status", header: _.find(props.fieldData.oppGatewaysHeaders, { header_name: "Status" })?.display_name, body: closeTemplate, headerClassName: "header-datatable", className: 'row-datatable' }
	]

	const parseDateString = (dateStr) => {
		if (dateStr != '' && dateStr != undefined) {
			const [day, month, year] = dateStr?.split('-').map(Number);
			return new Date(year, month - 1, day);
		}
	};

	const formatDate = (input) => {
		const date = (input instanceof Date) ? input : new Date(input);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	const handleCalenderInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: {
					...prevOpportunityDetails[field1][field2],
					text: value,
				},
			},
		}));
	};

	const handleRadioInputChange = (field1, field2, prevField, e) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: {
					...prevOpportunityDetails[field1][field2],
					value: e.value,
					checked: e.checked
				},
				[prevField]: {
					...prevOpportunityDetails[field1][prevField],
					checked: !e.checked
				}
			},
		}));
	};

	const handleButtonClick = () => {
		setShowVideo(true);
	};

	const closeVideo = () => {
		setShowVideo(false);
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="col-md-12 text-right">
				<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>
			{
				<form>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field col-md-8 pl-0'>
													{
														<div className="form-group row align-items-center mb-0 mt-0">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[0].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.target_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.target_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="est_close_1"
																	value={opportunityData.gateways?.est_target_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_target_gateway_approval", "act_target_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_target_gateway_approval.checked}
																/>
																<label htmlFor="est_close_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="est_close_2"
																	value={opportunityData.gateways?.act_target_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_target_gateway_approval", "est_target_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_target_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="est_close_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_target_gateway_approval.checked &&
																	<CalendarElement
																		id="estimated_close_gateways"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_target_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_target_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_target_gateway_approval.checked &&
																	<CalendarElement
																		id="estimated_close_gateways"
																		className='ml-10'
																		value={parseDateString(moment(opportunityData.gateways?.act_target_gateway_approval.text, "DD/MM/YYYY", true).isValid() ? moment(opportunityData.gateways?.act_target_gateway_approval.text, "DD/MM/YYYY").format("DD-MM-YYYY") : opportunityData.gateways?.act_target_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_target_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[1].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.pursuit_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.pursuit_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="quality_gateway_1"
																	value={opportunityData.gateways?.est_pursuit_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_pursuit_gateway_approval", "act_pursuit_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_pursuit_gateway_approval.checked}
																/>
																<label htmlFor="quality_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="quality_gateway_2"
																	value={opportunityData.gateways?.act_pursuit_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_pursuit_gateway_approval", "est_pursuit_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_pursuit_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="quality_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_pursuit_gateway_approval.checked &&
																	<CalendarElement
																		id="pursuit_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_pursuit_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_pursuit_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_pursuit_gateway_approval.checked &&
																	<CalendarElement
																		id="pursuit_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_pursuit_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_pursuit_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[2].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.pre_qualify_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.pre_qualify_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="qualify_gateway_1"
																	value={opportunityData.gateways?.est_pre_qualify_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_pre_qualify_gateway_approval", "act_pre_qualify_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_pre_qualify_gateway_approval.checked}
																/>
																<label htmlFor="qualify_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="qualify_gateway_2"
																	value={opportunityData.gateways?.act_pre_qualify_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_pre_qualify_gateway_approval", "est_pre_qualify_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_pre_qualify_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="qualify_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_pre_qualify_gateway_approval.checked &&
																	<CalendarElement
																		id="pre_qualify_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_pre_qualify_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_pre_qualify_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_pre_qualify_gateway_approval.checked &&
																	<CalendarElement
																		id="pre_qualify_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_pre_qualify_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_pre_qualify_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[3].text : ''} Mid Stage Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.submission_mid_phase_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.submission_mid_phase_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="mid_bid_1"
																	value={opportunityData.gateways?.est_submission_mid_phase_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_submission_mid_phase_gateway_approval", "act_submission_mid_phase_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_submission_mid_phase_gateway_approval.checked}
																/>
																<label htmlFor="mid_bid_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="mid_bid_2"
																	value={opportunityData.gateways?.act_submission_mid_phase_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_submission_mid_phase_gateway_approval", "est_submission_mid_phase_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_submission_mid_phase_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="mid_bid_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_submission_mid_phase_gateway_approval.checked &&
																	<CalendarElement
																		id="mid_bid_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_submission_mid_phase_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_submission_mid_phase_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_submission_mid_phase_gateway_approval.checked &&
																	<CalendarElement
																		id="mid_bid_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_submission_mid_phase_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_submission_mid_phase_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[3].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.submission_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.submission_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="tender_gateway_1"
																	value={opportunityData.gateways?.est_submission_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_submission_gateway_approval", "act_submission_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_submission_gateway_approval.checked}
																/>
																<label htmlFor="tender_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="tender_gateway_2"
																	value={opportunityData.gateways?.act_submission_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_submission_gateway_approval", "est_submission_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_submission_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="tender_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_submission_gateway_approval.checked &&
																	<CalendarElement
																		id="submission_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_submission_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_submission_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_submission_gateway_approval.checked &&
																	<CalendarElement
																		id="submission_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_submission_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_submission_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[4].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.appointment_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.appointment_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="negotiate_gateway_1"
																	value={opportunityData.gateways?.est_appointment_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_appointment_gateway_approval", "act_appointment_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_appointment_gateway_approval.checked}
																/>
																<label htmlFor="negotiate_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="negotiate_gateway_2"
																	value={opportunityData.gateways?.act_appointment_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_appointment_gateway_approval", "est_appointment_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_appointment_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="negotiate_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_appointment_gateway_approval.checked &&
																	<CalendarElement
																		id="appointment_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_appointment_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_appointment_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_appointment_gateway_approval.checked &&
																	<CalendarElement
																		id="appointment_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_appointment_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_appointment_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[5].text : ''} Mid-Project Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.deliver_mid_phase_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.deliver_mid_phase_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="mid_construct_1"
																	value={opportunityData.gateways?.est_deliver_mid_phase_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_deliver_mid_phase_approval", "act_deliver_mid_phase_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_deliver_mid_phase_approval.checked}
																/>
																<label htmlFor="mid_construct_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="mid_construct_2"
																	value={opportunityData.gateways?.act_deliver_mid_phase_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_deliver_mid_phase_approval", "est_deliver_mid_phase_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_deliver_mid_phase_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="mid_construct_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_deliver_mid_phase_approval.checked &&
																	<CalendarElement
																		id="deliver_mid_phase_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_deliver_mid_phase_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_deliver_mid_phase_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_deliver_mid_phase_approval.checked &&
																	<CalendarElement
																		id="deliver_mid_phase_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_deliver_mid_phase_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_deliver_mid_phase_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[5].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.deliver_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.deliver_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="deliver_gateway_1"
																	value={opportunityData.gateways?.est_deliver_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_deliver_gateway_approval", "act_deliver_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_deliver_gateway_approval.checked}
																/>
																<label htmlFor="deliver_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="deliver_gateway_2"
																	value={opportunityData.gateways?.act_deliver_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_deliver_gateway_approval", "est_deliver_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_deliver_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="deliver_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_deliver_gateway_approval.checked &&
																	<CalendarElement
																		id="deliver_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_deliver_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_deliver_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_deliver_gateway_approval.checked &&
																	<CalendarElement
																		id="deliver_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_deliver_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_deliver_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
													{
														<div className="form-group row align-items-center mb-0 mt-10">
															<div className="col-md-4 pl-0">
																<label className="form-label text-left">{props.winWorkStage.length > 0 ? props.winWorkStage[6].text : ''} Approval:</label>
															</div>
															<div className="col-md-1 pl-0">
																{
																	props.customerTooltipGateway?.approval_dates.feedback_gateway_approval.status == true &&
																	<div>
																		<Tooltip target=".custom-target-icon" />

																		<i className="custom-target-icon pi pi-info-circle tooltip-font"
																			data-pr-tooltip={props.customerTooltipGateway?.approval_dates.feedback_gateway_approval.text}
																			data-pr-position="right">
																		</i>
																	</div>
																}
															</div>
															<div className='col-md-4 pr-0'>
																<RadioButton
																	inputId="approval_gateway_1"
																	value={opportunityData.gateways?.est_feedback_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "est_feedback_gateway_approval", "act_feedback_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.est_feedback_gateway_approval.checked}
																/>
																<label htmlFor="approval_gateway_1" className="p-radiobutton-label">
																	Est
																</label>
																<RadioButton
																	inputId="approval_gateway_2"
																	value={opportunityData.gateways?.act_feedback_gateway_approval.value}
																	onChange={(e) => {
																		handleRadioInputChange("gateways", "act_feedback_gateway_approval", "est_feedback_gateway_approval", e);
																	}}
																	checked={opportunityData.gateways?.act_feedback_gateway_approval.checked}
																	className='ml-20'
																/>
																<label htmlFor="approval_gateway_2" className="p-radiobutton-label">
																	Act
																</label>
															</div>
															<div className='col pr-0'>
																{
																	opportunityData.gateways?.est_feedback_gateway_approval.checked &&
																	<CalendarElement
																		id="feedback_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.est_feedback_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "est_feedback_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
																{
																	opportunityData.gateways?.act_feedback_gateway_approval.checked &&
																	<CalendarElement
																		id="feedback_gateway_approval"
																		className='ml-10'
																		value={parseDateString(opportunityData.gateways?.act_feedback_gateway_approval.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("gateways", "act_feedback_gateway_approval", formatDate(value.value));
																		}}
																		placeholder="Date"
																	/>
																}
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field">
													<DataTable
														value={opportunityData.gateways?.gateway_status.length > 0 ? opportunityData.gateways?.gateway_status : []}
														columns={columns1}
														dataKey="_id"
														isNewField={true}
													/>
												</div>
											}
											{
												key == 'obj3' &&
												<div className="new-field w-50">
													{
														_.find(props.fieldData.oppGatewaysTable, { table_name: "Gateway checklist for winWork Stage" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={gateChecklist.length > 0 ? gateChecklist : []}
																	columns={columns}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
					<Dialog id="videoModal" visible={showVideo}
						breakpoints={{
							'1200px': '80vw',    // Larger modal on bigger screens
							'1024px': '85vw',    // Slightly smaller for medium screens
							'769': '90vw',     // Responsive on tablets
							'641px': '95vw',     // Almost full-width on mobile
						}}
						modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
					>
						<div className="video-overlay">
							<div className="video-container">
								<PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_gateways" />
							</div>
						</div>
					</Dialog>
				</form>
			}
		</div>
	)
}

export default Milestones